import {useAppSelector} from 'store/hooks';
import type {EditMode} from '../types';
import {selectMetadataEditEditModes} from '../metadataEditSlice';

export const useEditMode = (
  id: string,
  key: string,
  defaultValue: EditMode,
): EditMode => {
  return useAppSelector(
    state => selectMetadataEditEditModes(state)?.[id]?.[key] ?? defaultValue,
  );
};
